import confetti from "canvas-confetti";
import { toast } from "sonner";
import { api } from "./api";

let inflight = false;

/**
 * Re-run server-side sigil checks. If any are newly awarded, fire a celebratory
 * confetti burst + sonner toasts (one per sigil) tinted to each sigil's color.
 *
 * Call after meaningful actions (publish a deep dive, file a witness statement,
 * post a bounty, etc.) AND on every Profile page load.
 *
 * Returns the array of full sigil objects newly awarded (for any caller-specific UI).
 */
export async function celebrateNewSigils() {
  if (inflight) return [];
  inflight = true;
  try {
    const r = await api.post("/me/sigils/check").catch(() => null);
    if (!r?.data) return [];
    const newly = r.data.newly_awarded_full || [];
    if (!Array.isArray(newly) || newly.length === 0) return [];

    // Stagger the confetti so multiple unlocks feel separate, not piled-on.
    newly.forEach((s, i) => {
      setTimeout(() => {
        const color = s.color || "#a78bfa";
        confetti({
          particleCount: 80,
          spread: 70,
          origin: { y: 0.4 },
          colors: [color, "#ffffff", color, "#a78bfa"],
          ticks: 180,
          scalar: 0.9,
        });
        // Second burst slightly off-center for depth
        setTimeout(() => {
          confetti({
            particleCount: 50,
            spread: 100,
            origin: { x: 0.3 + Math.random() * 0.4, y: 0.5 },
            colors: [color, color, "#ffffff"],
            ticks: 140,
          });
        }, 200);
        toast.success(`SIGIL UNLOCKED: ${s.name}`, {
          description: s.description,
          duration: 6000,
          style: {
            background: "#0a0a0a",
            border: `1px solid ${color}`,
            color: "#fff",
            boxShadow: `0 0 0 1px ${color}55, 0 20px 50px -25px ${color}88`,
          },
        });
      }, i * 900);
    });
    return newly;
  } finally {
    inflight = false;
  }
}
